import React, { useEffect } from 'react';
import './CosmicVoyage.css';
import logo from '../../assets/logo.png';


const CosmicVoyage = () => {
    
    useEffect(() => {
        const starField = document.getElementById('starField');
        for (let i = 0; i < 200; i++) {
            const star = document.createElement('div');
            star.className = 'star';
            star.style.left = `${Math.random() * 100}%`;
            star.style.top = `${Math.random() * 100}%`;
            star.style.animationDuration = `${Math.random() * 3 + 2}s`;
            star.style.animationDelay = `${Math.random() * 3}s`;
            starField.appendChild(star);
        }

        document.addEventListener('mousemove', (e) => {
            const mouseX = e.clientX / window.innerWidth - 0.5;
            const mouseY = e.clientY / window.innerHeight - 0.5;

            starField.style.transform = `translate(${mouseX * 20}px, ${mouseY * 20}px)`;
        });

        starField.querySelectorAll('.star').forEach(star => {
            const size = Math.random() * 2 + 1;
            star.style.width = `${size}px`;
            star.style.height = `${size}px`;

            const r = Math.floor(Math.random() * 55 + 200);
            const g = Math.floor(Math.random() * 100 + 155);
            const b = Math.floor(Math.random() * 155 + 200);

            star.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;

            star.style.filter = `blur(${Math.random()}px)`;
        });

        setInterval(() => {
            if (Math.random() > 0.9) {
                const shootingStar = document.createElement('div');
                shootingStar.className = 'star';
                shootingStar.style.left = `${Math.random() * 100}%`;
                shootingStar.style.top = `${Math.random() * 100}%`;
                shootingStar.style.width = '3px';
                shootingStar.style.height = '3px';
                shootingStar.style.backgroundColor = '#fff';
                shootingStar.style.boxShadow = '0 0 10px #fff, 0 0 20px #fff';
                shootingStar.style.animation = `shooting-star 1s linear`;

                starField.appendChild(shootingStar);

                setTimeout(() => {
                    starField.removeChild(shootingStar);
                }, 1000);
            }
        }, 100);

        const style = document.createElement('style');
        style.textContent = `
            @keyframes shooting-star {
                0% { transform: translateX(0) translateY(0); opacity: 1; }
                100% { transform: translateX(1000px) translateY(1000px); opacity: 0; }
            }
        `;
        document.head.appendChild(style);
    }, []);

    const getRandomPosition = (element) => {
        const viewportWidth = window.innerWidth - element.clientWidth;
        const viewportHeight = window.innerHeight - element.clientHeight;

        const randomLeft = Math.floor(Math.random() * viewportWidth);
        const randomTop = Math.floor(Math.random() * viewportHeight);

        return { top: randomTop, left: randomLeft };
    };

    const applyRandomPosition = (className) => {
        const dragons = document.querySelectorAll(className);

        dragons.forEach(dragon => {
            const { top, left } = getRandomPosition(dragon);
            dragon.style.left = `${left}px`;
            dragon.style.top = `${top}px`;
        });
    };

    useEffect(() => {
        applyRandomPosition('.ag-dragon');
        applyRandomPosition('.ag-dragon-small');
        // eslint-disable-next-line 
    }, []);

    return (
        <>
        <div className="star-field" id="starField"></div>
            <div className="absolute inset-0 h-[100vh] flex flex-row items-center justify-center z-10 landingtwo">
                <div className="w-[40%] flex items-center justify-center ">
                    <img src={logo} className="w-full object-contain" alt="" />
                    <p className='absolute text-[2.7rem]  xptext tracking-wide text-white l'>XPLORE'24</p>
                </div>
                <div className="w-[50%] flex flex-col items-center justify-center gap-5 text-center bg-black bg-opacity-30 bg-blur-[20px] rounded-lg p-6 xploreintro">
                    <p className="text-[1.3rem] about-xplore font-small text-white tracking-wide">
                    Xplore'24 is a national level technical fest featuring a variety of technical games. Participants from various colleges will have the opportunity to showcase their skills, compete in innovative challenges, and win exciting prizes, making it a thrilling event for tech enthusiasts looking to test their abilities and connect with like-minded peers.
                    </p>
                    <a className="w-[max-content] px-4 py-2 bg-black bg-opacity-65 py-2 px-4 text-gray-200 border-[1px] border-gray-300 rounded cursor-pointer transition-all duration-500 hover:scale-105 hover:text-white"
                     href="https://docs.google.com/forms/d/e/1FAIpQLSd6sKWFJsDMbNtaIVyGpEdilxImJXRCOZj3-LLnHIGt28OtXg/viewform" 
                     target="_blank" 
                     >
                        Register
                     </a>
                </div>
            </div>

        </>
    );
};

export default CosmicVoyage;